import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Badge from 'react-bootstrap/Badge';
import Loader from '../../component/loader';
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import { AiOutlinePullRequest, AiOutlineCheckCircle } from "react-icons/ai";
import axios from 'axios';
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SellerList() {
  const [loader, setLoader] = useState(false)
  const [sellerList, setSellerList] = useState();
  const [sellerShow, setSellerShow] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [statusShow, setStatusShow] = useState();
  const [status, setStatus] = useState();
  const [deleteShow, setDeleteShow] = useState(false);
  const [sellerToDelete, setSellerToDelete] = useState(null);
  const [sellerStatus, setSellerStatus] = useState({
    status: ''
  });
  console.log(sellerStatus, 'sellerStatus');
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const fetchSellerList = async (registration_status) => {
    setLoader(true);
    const data = {
      registration_status: registration_status,
    }
    console.log(data, 'chekc data sjdsajd')
    let token = decrpt(Cookies.get('s_l'));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const response = await axios.post(`/admin/seller/all/list`, data)
      .then((response) => {
        console.log('sellers list data', response.data.data)
        setSellerList(response.data.data.list);
        setLoader(false);
        console.log(response.data, 'seller list');
      }).catch((err) => {
        console.log('seller list error', err)
        setLoader(false);
      })
  }

  // Filtered sellers by search
  const filteredSellers = useMemo(() => {
    if (!Array.isArray(sellerList)) return [];
    if (!searchText.trim()) return sellerList;
    const q = searchText.trim().toLowerCase();
    return sellerList.filter((s) => {
      const name = (s.name || "").toLowerCase();
      const mobile = (s.mobile || "").toLowerCase();
      const email = (s.email || "").toLowerCase();
      const id = String(s.id || "").toLowerCase();
      return name.includes(q) || mobile.includes(q) || email.includes(q) || id.includes(q);
    });
  }, [sellerList, searchText]);

  // Pagination logic
  const totalItems = filteredSellers.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  // Keep currentPage within valid range whenever totalPages or itemsPerPage changes
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedSellers = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredSellers.slice(startIndex, endIndex);
  }, [filteredSellers, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  const statusTypeHandler = (registration_status) => {
    fetchSellerList(registration_status);
    setSelectedStatus(registration_status);
    setCurrentPage(1);
  }

  const handleStatus = (item) => {
    setStatusShow(true);
    setStatus(item);
    console.log(status, 'dsdsjdk item');
  };
  const handleStatusClose = () => {
    setStatusShow(false);
  };

  //  seller approve
  const sellerApprove = async (id) => {
    setLoader(true);
    const data = { id: id }
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/seller/approve`, data)
      if (response.data) {
        toast.success(response.data.message || 'Seller approved successfully!', { hideProgressBar: true });
        fetchSellerList(selectedStatus);
      }
    } catch (error) {
      console.log('Error', error);
      toast.error(error.response?.data?.message || 'Failed to approve seller', { hideProgressBar: true });
      setLoader(false);
    }
  }
  //  seller approve

  // seller enable api
  const sellerEnable = async () => {
    setLoader(true);
    let newstatus = '';
    if (status.status == 1) {
      newstatus = 2;
    } else {
      newstatus = 1;
    }
    const data = {
      id: status.id,
      status: newstatus
    }
    console.log(data, 'data');
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/seller/status/update`, data)
        .then((response) => {
          let tmparray = sellerList;
          let obj = tmparray.find((o, i) => {
            if (o.id === status.id) {
              tmparray[i] = { ...sellerList[i], status: newstatus };
              return true;
            }
          });
        })
      setStatusShow(false);
      setLoader(false);
    } catch (error) {
      console.log('Error', error);
      setLoader(false);
    }
  }

  // seller enable api

  // filtrer api fecth
  const sellerIdSend = (item) => {
    navigate('./single', { state: { item } });
  }

  const handleDeleteClick = (item) => {
    setSellerToDelete(item);
    setDeleteShow(true);
  };

  const confirmDeleteSeller = async () => {
    if (!sellerToDelete) return;
    setLoader(true);
    setDeleteShow(false);
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/seller/delete`, { id: sellerToDelete.id });
      if (response.data.success) {
        toast.success(response.data.message || 'Seller deleted successfully', { hideProgressBar: true });
        setSellerList((prev) => (Array.isArray(prev) ? prev.filter((s) => s.id !== sellerToDelete.id) : []));
        setSellerToDelete(null);
        setLoader(false);
      } else {
        toast.error(response.data.message || 'Failed to delete seller', { hideProgressBar: true });
        setLoader(false);
      }
    } catch (error) {
      console.log('Error', error);
      toast.error(error.response?.data?.message || 'Failed to delete seller', { hideProgressBar: true });
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSellerList();
  }, []);

  // useEffect(() => {
  //   setSellerStatus({
  //     ...sellerStatus,
  //           id    : sellerList  ? sellerList.id : '',
  //         status : sellerList ? sellerList.status : ''
  //   })
  // },[sellerList]);



  return (
    <div className="main-content">
      {loader ?
        <Loader />
        :
        <>
          {/* New User Registration */}
          <div className="section sellerList">
            <div className="row">
              <div className="col-md-12">
                <div className="count-section d-flex justify-content-left flex-wrap gap-2">
                  {/* count all */}
                  <button
                    className="product-page-block d-flex align-items-center me-2"
                    onClick={() => statusTypeHandler(undefined)}
                    style={!selectedStatus ? styles.activeBtn : null}
                  >
                    <div className="product-page-inner-block">
                      <h5 style={!selectedStatus ? styles.activeBtnTxt : null}>
                        <AiOutlinePullRequest /> All Sellers
                      </h5>
                    </div>
                  </button>
                  {/* count 1 */}
                  <button className="product-page-block d-flex align-items-center me-2" onClick={() => statusTypeHandler(6)} style={selectedStatus == 6 ? styles.activeBtn : null}>
                    <div className="product-page-inner-block">
                      <h5 style={selectedStatus && selectedStatus == 6 ? styles.activeBtnTxt : null}><AiOutlinePullRequest /> Approved</h5>
                    </div>
                  </button>
                  {/* count 2 */}
                  <button className="product-page-block d-flex align-items-center" onClick={() => statusTypeHandler(5)} style={selectedStatus == 5 ? styles.activeBtn : null}>
                    <div className="product-page-inner-block">
                      <h5 style={selectedStatus && selectedStatus == 5 ? styles.activeBtnTxt : null}><AiOutlineCheckCircle /> Pending</h5>
                    </div>
                  </button>
                </div>

                {/* New Order */}
                <div className="card p-2">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <h5>All Seller</h5>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Mobile, Name, Email, ID..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className='table table-bordered'>
                      <thead>
                        <tr>
                          <th>SL</th>
                          <th>Seller Name</th>
                          <th className="text-center">Date of Registration</th>
                          <th className="text-center">Mobile Number</th>
                          <th className="text-center">Email</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedSellers && paginatedSellers.length > 0 ?
                          <>
                            {paginatedSellers.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item.id}</td>
                                  <td>{item.name || <span className="text-muted fst-italic">No Name</span>}</td>
                                  <td className="text-center">  {moment(item.created_at).format("DD, MMMM , YYYY")} </td>
                                  <td className="text-center"><strong>{item.mobile}</strong></td>
                                  <td className="text-center">{item.email || <span className="text-muted fst-italic">—</span>}</td>
                                  <td className="text-center">
                                    {item.registration_status < 5 ? (
                                      <Badge bg="secondary">Incomplete ({item.registration_status == 1 ? 'OTP' : item.registration_status == 2 ? 'Basic' : item.registration_status == 3 ? 'Business' : 'Bank'})</Badge>
                                    ) : item.registration_status == 5 ? (
                                      <Badge bg="danger">Not Approved</Badge>
                                    ) : item.registration_status == 6 && item.status == 2 ? (
                                      <Badge bg="danger">Disabled</Badge>
                                    ) : (
                                      <Badge bg="success">Enabled</Badge>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <button type="button" className='btn btn-xs btn-primary text-white me-1' onClick={() => sellerIdSend(item)} >View</button>
                                    {/* {item.status == 2 ?<button type="button" className='btn btn-xs btn-warning text-black me-1' >Make Enable</button> :<button type="button" className='btn btn-xs btn-secondary text-white me-1' >Make Disable</button>} */}
                                    {item.registration_status == 6 && item.status == 1 ?
                                      <button type="button" className='btn btn-xs btn-danger text-white me-1' onClick={() => handleStatus(item)} >Make Disable</button> :
                                      (item.registration_status == 6 && item.status == 2 ?
                                        <button type="button" className='btn btn-xs btn-warning text-dark me-1' onClick={() => handleStatus(item)} >Make enable</button> : ''
                                      )}
                                    {item.registration_status == 5 ? (
                                      <button type="button" className='btn btn-xs btn-success text-white me-1' onClick={() => sellerApprove(item.id)} > Make Approve </button>
                                    ) : ''}
                                    <button type="button" className='btn btn-xs btn-danger text-white' onClick={() => handleDeleteClick(item)}>Delete</button>
                                  </td>
                                </tr>
                              );
                            })}
                          </> :
                          <tr><td colSpan={7} className="text-center">No data found</td></tr>
                        }
                      </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div className="flex items-center justify-between mt-4 px-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '1rem', padding: '0 0.5rem', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>Show</span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{ padding: '0.25rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', outline: 'none', background: '#fff' }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>entries</span>
                        </div>

                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span className="text-sm font-medium px-2 text-gray-700" style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}>
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Modal size="md" show={statusShow} onHide={handleStatus} centered>
              <Modal.Header className="py-1">
                <Modal.Title className="h6">Do you want to  {
                  status && status.status == 1 ? 'Disable' : 'Enable'
                } category ? <br /><span className="text-danger text-capitalize fw-bold">{status && status.name}</span></Modal.Title>
              </Modal.Header>
              <Modal.Footer className="p-1 justify-content-start">
                <button onClick={() => handleStatusClose()} className="btn btn-light btn-sm">
                  Close
                </button>
                <button className="btn btn-primary btn-sm" onClick={() => sellerEnable()} >
                  {status && status.status == 1 ? 'Make Disable' : 'Make Enable'}
                </button>
              </Modal.Footer>
            </Modal>

            {/* Delete Seller Modal */}
            <Modal size="sm" show={deleteShow} onHide={() => setDeleteShow(false)} centered>
              <Modal.Header>
                <Modal.Title className="h6 fw-bolder">Are You Sure to Delete this Seller?</Modal.Title>
              </Modal.Header>
              <Modal.Body className="py-2">
                <p className="mb-0 text-muted" style={{ fontSize: '13px' }}>
                  <strong>{sellerToDelete?.name}</strong> {sellerToDelete?.email ? `(${sellerToDelete.email})` : ''}
                </p>
                <small className="text-danger">This will delete the seller account and associated products. This action cannot be undone.</small>
              </Modal.Body>
              <Modal.Footer className="p-1 justify-content-start">
                <button onClick={() => setDeleteShow(false)} className="btn btn-light btn-sm">
                  No
                </button>
                <button onClick={() => confirmDeleteSeller()} className="btn btn-danger btn-sm">
                  Yes, Delete
                </button>
              </Modal.Footer>
            </Modal>

            <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme={'colored'} />
          </div>
        </>
      }
    </div>

  );
}

export default SellerList;

const styles = {
  activeTable: { disply: 'table-row' },
  inActiveTable: { display: 'none' },
  activeBtn: { backgroundColor: '#ffc001ad' },
  activeBtnTxt: { color: '#000' },
}; 